import { observable, action, computed, reaction } from 'mobx'
import { Affiliate, createStub } from '../Model/AffiliateModel'
import ActionsLocalService from '../Services/ActionsLocalService'
import { ExportType } from './ExportStore'

export default class AffiliatesStore {

    @observable
    private item: Affiliate | null

    @observable
    private list: Array<Affiliate>

    private static _instance: AffiliatesStore

    private constructor() {
        this.list = []

        reaction(
            () => this.list,
            _ => {
                let data = createStub(this.list)
                ActionsLocalService.getInstance().setExportData(ExportType.Affiliates, data)
            }
        )
    }

    public static getInstance(): AffiliatesStore {
        return this._instance || (this._instance = new this())
    }

    @action.bound
    setList(list: Array<Affiliate>): void {
        this.list = list
    }

    @computed
    get getList(): Array<Affiliate> {
        return this.list
    }

    @action.bound
    setItem(item: Affiliate | null) {
        this.item = item
    }

    @computed
    get getItem(): Affiliate | null {
        return this.item
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/AffiliatesStore.ts